module.exports = __webpack_public_path__ + "static/media/service.ac091ce8.svg";